
import { EventInput } from '@fullcalendar/core'

let eventGuid = 0
let todayStr = new Date().toISOString().replace(/T.*$/, '') // YYYY-MM-DD of today

export const INITIAL_EVENTS: EventInput[] = [
  {
    id: createEventId(),
    title: 'Cita Médica',
    start: '2022-11-28T12:45:00'
  },
  {
    id: createEventId(),
    title: 'Cita Mindfulness',
    start: '2022-11-24T13:15:00'
  },
  {
    id: createEventId(),
    title: 'Cita Nutrición',
    start: '2022-11-24T15:30:00'
  },
  {
    id: createEventId(),
    title: 'Cita Mindfulness Ayala Gamarra Carlos',
    start: '2022-11-22T19:35:00'
  },
  {
    id: createEventId(),
    title: 'Cita Paciente Ayala Gamarra Carlos',
    start: '2022-11-09T15:20:00'
  }
]

export function createEventId() {
  return String(eventGuid++)
}